import './settlement-history.scss';

import { formatWallet } from '@basqet-dashboard/common/utils';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { useFetchSettlements } from '../../hooks/queries';
import { formatFiatCurrency } from '../../utils';

const SettlementHistory = () => {
  const { isLoading, recentSettlements } = useFetchSettlements();
  return (
    <div className="card settlement-history">
      <div className="card__header">
        <h3 className="card__title">
          Settlement <span className="text-cursive">history</span>
        </h3>
      </div>
      <div className="settlement-history__list">
        {recentSettlements &&
          recentSettlements.map((item) => (
            <SettlementHistoryItem settlement={item} key={item.id} />
          ))}
        {!recentSettlements.length && isLoading && (
          <>
            <LoadingSettlementHistoryItem />
            <LoadingSettlementHistoryItem />
            <LoadingSettlementHistoryItem />
          </>
        )}
        {!recentSettlements.length && !isLoading && <SettlementHistoryEmpty />}
      </div>
      <div className="card__footer">
        <Link to="/settlement" className="card__footer__link">
          See all settlements <ArrowRight />
        </Link>
      </div>
    </div>
  );
};

const SettlementHistoryItem = ({ settlement }) => {
  const created_at = format(new Date(settlement.created_at), 'dd - MM - yyyy');
  const { settlement_account, currency } = settlement;
  const settlement_address = formatWallet(settlement_account?.account_address);
  const account_provider = settlement_account?.account_provider;
  const currency_slug = currency?.slug;

  return (
    <div className="settlement">
      <div>
        <p className="settlement__amount">
          {currency_slug ? `${currency_slug.toUpperCase()} ` : ''}
          {formatFiatCurrency(settlement.amount)}
        </p>
        <p>
          {settlement_address}
          {` || `}
          {account_provider ?? currency_slug}
        </p>
      </div>
      <div className="text-right">
        <p>{created_at}</p>
      </div>
    </div>
  );
};

const LoadingSettlementHistoryItem = () => {
  return (
    <div className="settlement loader">
      <div>
        <div className="settlement__amount loading">
          <div className="bar"></div>
        </div>
        <div className="loading">
          <div className="bar"></div>
        </div>
      </div>
      <div className="text-right">
        <div className="loading">
          <div className="bar"></div>
        </div>
        <div className="loading">
          <div className="bar"></div>
        </div>
      </div>
    </div>
  );
};
SettlementHistoryItem.propTypes = {
  settlement: PropTypes.object
};

const SettlementHistoryEmpty = () => {
  return (
    <div className="settlement__empty">
      <p>No settlements found</p>
    </div>
  );
};

export { LoadingSettlementHistoryItem, SettlementHistory };
